import axios, { endpoints } from 'src/utils/axios';

export const ChangePassword = async (data) => {
  const response = await axios.post('/api/User/changePassword', data);
  return response;
};

export const ResetPassword = async () => {
  const response = await axios.patch('/api/User/resetPassword');
  return response;
};

export const ResetPasswordByAdmin = async (userId) => {
  const url = endpoints.auth.resetPasswordByAdmin.replace('{userId}', userId);
  const response = await axios.post(url);
  return response;
};

export const GetUser = async () => {
  const response = await axios.get('/api/User/profile');
  return response;
};

// Token mínimo y de vida corta para conectarse a los hubs de SignalR.
//
// POR QUÉ NO SE USA EL JWT DE SESIÓN. SignalR no puede fijar el header Authorization al abrir
// un WebSocket, así que el token viaja en la querystring. El JWT de sesión pesa ~8,9 KB (un
// claim por cada uno de los 177 permisos, más la entidad de usuario serializada), lo que daba
// una URL que Kestrel rechazaba por MaxRequestLineSize: 414 sobre HTTP/1.1 y corte de stream
// sobre HTTP/2 (ERR_HTTP2_PROTOCOL_ERROR), con el cliente reintentando en bucle. Además metía
// salario, dirección y teléfonos del empleado en el historial del navegador y en los logs de
// acceso del servidor.
//
// Este token lleva solo el id de usuario (~300 bytes) y el backend lo rechaza fuera de rutas
// /api/hub, así que filtrarlo no abre el resto de la API.
export const getHubToken = async () => {
  const response = await axios.get('/api/User/hub-token');
  return response.data?.token ?? '';
};

export const GetUserById = async (userId) => {
  try{
    const response = await axios.get(`/api/User/${userId}`);
    return response;
  }catch(err){
    console.log(err)
    return null;
  }
};

export const CreateUser = async (data) => {
  const response = await axios.post('/api/User', data);
  return response;
};

export const UpdateUser = async (id, data) => {
  const response = await axios.put(`/api/User/profile${id}`, data);
  return response;
};

export const getAllUsers = async () => {
  const response = await axios.get('/api/User');
  return response;
};

export const DeleteUser = async (id) => {
  const response = await axios.delete(`/api/User/${id}`);
  return response;
};

export const EnableDesableUser = async (id) => {
  const response = await axios.put(`/api/User/EnableDesableUser${id}`);
  return response;
};
